export default __webpack_public_path__ + "static/media/Empty.c762e5ea.jpeg";